import React from "react";
import styles from "./Readmore.module.css";
import { FaUser } from "react-icons/fa";

const ReadMoreAnnouncement = ({ author = "Eswar", message="welcome"}) => {
  return (
    <div className={styles.wrapper}>
      {/* Header Tab */}
      <div className={styles.header}>
        ANNOUNCEMENTS
      </div>

      {/* Card */}
      <div className={styles.card}>
        <div className={styles.author}>
          <FaUser className={styles.icon} />
          <span>{author}</span>
        </div>

        <div className={styles.content}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default ReadMoreAnnouncement;
